export default "__VITE_ASSET__CJR7ivyy__"